import { render, staticRenderFns } from "./EditNexoTransaction.vue?vue&type=template&id=295e4310&"
import script from "./EditNexoTransaction.vue?vue&type=script&lang=js&"
export * from "./EditNexoTransaction.vue?vue&type=script&lang=js&"
import style0 from "./EditNexoTransaction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports